/**
 * @class - simple class ensures types dont get repeated often
 */
export default class TypePool {

    constructor(types) {
        this._types = types;
        this._pool = [];
    }

    _fill() {
        this._pool = P3.utils.shuffleArray(JSON.parse(JSON.stringify(this._types)));
    }

    draw() {
        if (this._pool.length === 0)
            this._fill();

        return this._pool.pop();
    }

}